import React, { useState } from 'react';

import licenseIcon from '../../assets/icons/license.svg';
import userIcon from '../../assets/icons/user.svg';
import securityIcon from '../../assets/icons/security.svg';
import accountIcon from '../../assets/icons/account.svg';
import AccountSetting from '../../components/Setting/AccountSetting';
import LicenseSetting from '../../components/Setting/LicenseSetting';
import PasswordSetting from '../../components/Setting/PasswordSetting';
import UserSetting from '../../components/Setting/UserSetting';
import styles from '../../css/setting/settings-modal.module.css';

interface Props {
    open: boolean;
    onClose: () => void;
}

const SettingsModal: React.FC<Props> = ({ open, onClose }) => {
    const [activeTab, setActiveTab] = useState('User');

    if (!open) return null;

    const tabs = [
        { name: 'License', icon: licenseIcon },
        { name: 'User', icon: userIcon },
        { name: 'Security', icon: securityIcon },
        { name: 'Account', icon: accountIcon }
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'License':
                return <LicenseSetting />;
            case 'User':
                return <UserSetting />;
            case 'Security':
                return <PasswordSetting />;
            case 'Account':
                return <AccountSetting />;
            default:
                return null;
        }
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2>Settings</h2>
                    <button className={styles.closeButton} onClick={onClose}>✕</button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.sidebar}>
                        {tabs.map((tab) => (
                            <button
                                key={tab.name}
                                className={activeTab === tab.name ? styles.activeSidebarItem : styles.sidebarItem}
                                onClick={() => setActiveTab(tab.name)}
                            >
                                <img src={tab.icon} alt={`${tab.name} icon`} className={styles.sidebarIcon} />
                                {tab.name}
                            </button>
                        ))}
                    </div>
                    <div className={styles.content}>
                        {renderContent()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;
